<!--
 * 用户名密码注册组件
 *
 * @author zhoujianhui
 * @date 10/28/2021
 * @lastModifiedBy zhoujianhui
 * @lastModifiedDate 12/16/2021
 -->
<template>
  <div class="register">
    <el-row type="flex">
      <el-col :xs="24" :sm="24" :md="11" :lg="14" :xl="14"></el-col>

      <el-col :xs="24" :sm="24" :md="12" :lg="9" :xl="9">
        <el-form ref="registerForm" class="form"
                 :model="registerInfo" :rules="rules">
          <div class="welcome">注册</div>
          <el-form-item prop="username">
            <el-input placeholder="请输入用户名" v-model="registerInfo.username">
              <i slot="prefix" class="input-icon">
                <remix-icon icon="fas fa-user"/>
              </i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input placeholder="请输入密码" type="password" v-model.trim="registerInfo.password">
              <i slot="prefix" class="input-icon">
                <remix-icon icon="fas fa-lock"/>
              </i>
            </el-input>
          </el-form-item>
          <el-form-item prop="repeatedPassword">
            <el-input placeholder="请确认输入密码" type="password" autocomplete="off"
                      v-model.trim="registerInfo.repeatedPassword">
              <i slot="prefix" class="input-icon">
                <remix-icon icon="fas fa-lock"/>
              </i>
            </el-input>
          </el-form-item>
          <el-form-item prop="captchaText" style="position: relative;">
            <el-input placeholder="请输入图形验证码" v-model.trim="registerInfo.captchaText">
              <i slot="prefix" class="input-icon">
                <remix-icon icon="fas fa-calculator"/>
              </i>
              <div slot="suffix" class="input-suffix-icon">
                <img :src="captchaBase64" alt="无法获取图形验证码"/>
              </div>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="register-btn"
                       :loading="loading"
                       @click="handleRegisterBtnClick">注册
            </el-button>
            <router-link to="/">
              <div class="login">登录</div>
            </router-link>
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :xs="24" :sm="24" :md="1" :lg="1" :xl="1"></el-col>
    </el-row>
  </div>
</template>

<script>
import {noticeManager} from "@zhoujianhui/vip-core"
import registerService from "../service/register-service"
import UsernamePasswordRegisterInfo from "../model/UsernamePasswordRegisterInfo"

export default {
  name: "UsernamePasswordRegister",
  data() {
    return {
      loading: false,
      registerInfo: new UsernamePasswordRegisterInfo(),
      rules: UsernamePasswordRegisterInfo.getRules(this),
      captchaBase64: require("../../../assets/image/ellipsis.gif")
    }
  },
  created() {
    this.getImgCaptcha();
  },
  methods: {
    async getImgCaptcha() {
      const result = await registerService.getImgCaptcha()
      if (result.isSuccess()) {
        this.captchaBase64 = result.data.base64
        this.registerInfo.captchaToken = result.data.token
      } else {
        noticeManager.showMessage(result.msg, result.type)
      }
    },

    //////

    handleRegisterBtnClick() {
      this.$refs["registerForm"].validate(async (valid) => {
        if (valid) {
          this.loading = true;

          const result = await registerService.register(this.registerInfo);
          if (result.isSuccess()) {
            await this.$router.push("/")
          }
          noticeManager.showMessage(result.msg, result.type);

          this.loading = false;
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.register) {
  width: 100%;
  height: 100vh;
  background: url(../../../assets/image/login-background.jpg) 50% fixed no-repeat;
  background-size: cover;

  .form {
    position: relative;
    text-align: left;
    max-width: 100%;
    padding: 4.5vh;
    margin: calc(50vh - 340px) 5vw 0 5vw;
    overflow: hidden;
    background: url(../../../assets/image/login-form.png) no-repeat;
    background-size: 100% 100%;

    .welcome {
      margin: 9px 0 0;
      font-size: 26px;
      color: #fff;
    }

    .input-icon {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 3px;
      font-size: 15px;
      color: #d7dee3;
    }

    .input-suffix-icon {
      height: 100%;
      display: flex;
      align-items: center;
    }

    .image-captcha {
      position: absolute;
      top: 6px;
      right: 5px;
    }

    .sms-captcha-btn {
      text-align: center;
      width: 120px;
      height: 32px;
      font-size: 14px;
      color: #fff;
      background-color: #1890ff;
      border-color: #1890ff;

      &:hover {
        background: rgb(70, 166, 255);
        border-color: rgb(70, 166, 255);
      }

      &:active {
        background: rgb(70, 166, 255);
        border-color: rgb(70, 166, 255);
      }
    }

    .register-btn {
      display: inherit;
      width: 220px;
      height: 50px;
      margin-top: 5px;
      border: 0;
      padding: 9px 15px;
      font-size: 12px;
    }

    .login {
      margin-top: 20px;
      color: #1890ff;
      font-size: 14px;
    }

    & a {
      text-decoration: none;
    }

    .el-form-item {
      padding-right: 0;
      margin: 20px 0;
      color: #454545;
      background: transparent;
      border: 1px solid transparent;
      border-radius: 2px;

      &__error {
        position: absolute;
        top: 100%;
        left: 18px;
        font-size: $base-font-size-small;
        line-height: 18px;
        color: $base-color-red;
      }

      .el-input__inner {
        height: 48px;
        padding-left: 35px;
        line-height: 58px;
        background: #f6f4fc;
        border: 0;
        font-size: $base-font-size-default;
        color: $base-font-color;
      }
    }
  }
}
</style>